import { createSelector } from 'reselect';

const stateSelector = state => state.translations;

export const translationsSelector = createSelector(
  stateSelector,
  translations => translations.translations
);

export const languageSelector = createSelector(
  stateSelector,
  translations => translations.language
);

export const hasStaticTextsSelector = createSelector(
  stateSelector,
  ({ hasStaticTexts }) => hasStaticTexts
);

export const hasAllTextsSelector = createSelector(
  stateSelector,
  ({ hasStaticTexts, hasCustomerTexts }) => hasStaticTexts && hasCustomerTexts
);
